import { SpecName } from './../../models/spec-name.model';
import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { AutomationService } from '../../automation.service';
import { Router } from '@angular/router';
import { cloneDeep, intersection } from 'lodash';

@Component({
    selector: 'services-specification-names-list',
    templateUrl: './services-specification-names-list.component.html',
    styleUrls: ['./services-specification-names-list.component.css']
})
export class ServicesSpecificationNamesListComponent implements OnInit {

    public specNames: SpecName[] = [];

    public shownSpecNames: SpecName[] = [];

    public services: string[] = [];

    public selectedServices: string[] = [];

    public generateArrayFromObj = null;

    public errorOverLay = null;

    constructor(private automationService: AutomationService, private router: Router) { }

    public ngOnInit() {

        this.generateArrayFromObj = this.automationService.generateArrayFromObj;

        this.automationService.registerSpinner.next(true);

        this.automationService.listSpecNames()
            .subscribe((data) => {

                this.specNames = data.specNames;

                this.shownSpecNames = cloneDeep(this.specNames);

                this.services = data.services;

                this.automationService.registerSpinner.next(false);
            }, (error) => {
                    this.automationService.registerSpinner.next(false);

                    if (error && error.json) {

                        this.errorOverLay = {
                            message: error.json().message
                        };
                    }
            });
    }


    public deleteSpecName(id: string, specNameIndex: number) {

        this.automationService.registerSpinner.next(true);

        this.automationService.removeSpecName(id)
            .subscribe(() => {

                this.automationService.registerSpinner.next(false);

                this.shownSpecNames.splice(specNameIndex, 1);

                const indexInStore: number = this.specNames.findIndex((specName: SpecName) => specName._id === id);

                this.specNames.splice(indexInStore, 1);
            }, (error) => {

                if (error && error.json) {

                    this.errorOverLay = {
                        message: error.json().message
                    };
                }

                this.automationService.registerSpinner.next(false);
            });
    }

    public editSpecName(specNameId: string) {

        this.router.navigate(['/automation/service-spec-name-edit/' + specNameId]);
    }


    public selectOrUnselectService(service: string) {

        const serviceIndex: number = this.selectedServices.indexOf(service);

        if (serviceIndex >= 0) {

            this.selectedServices.splice(serviceIndex, 1);
        } else {

            this.selectedServices.push(service);
        }
    }

    public filterSpecNames() {

        if (this.selectedServices.length) {

            this.shownSpecNames = this.specNames.filter((specName: SpecName) => {

                const flows = Object.keys(specName.flows);

                return intersection(this.selectedServices, flows).length > 0;
            });

        }

    }

    public resetFilter() {

        this.selectedServices = [];

        this.shownSpecNames = cloneDeep(this.specNames);
    }

    public expandPanel() {

        const element = document.getElementById('collapsible-btn');

        element.classList.toggle("active");

        const content: any = element.nextElementSibling;

        if (content.style.display === "block") {

            content.style.display = "none";
        } else {
            content.style.display = "flex";
        }
    }

    closeOverLay() {

        this.errorOverLay = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/automation/services-specification-names/list/services-specification-names-list.component.ts